interface InputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'className'> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
  inputClassName?: string;
}

export function Input({ label, error, fullWidth, inputClassName = '', id, ...props }: InputProps) {
  const inputId = id ?? `input-${Math.random().toString(36).slice(2)}`;
  return (
    <div className={`form__field ${fullWidth ? 'form__field_full' : ''}`}>
      {label && (
        <label htmlFor={inputId} className="form__label">
          {label}
        </label>
      )}
      <input
        id={inputId}
        className={`form__input ${error ? 'form__input_error' : ''} ${inputClassName}`}
        aria-invalid={!!error}
        aria-describedby={error ? `${inputId}-error` : undefined}
        {...props}
      />
      {error && (
        <span id={`${inputId}-error`} className="form__error" role="alert">
          {error}
        </span>
      )}
    </div>
  );
}
